import { graphql, useStaticQuery } from 'gatsby';

export default function allBlogs() {
  return useStaticQuery(graphql`
    query GetBlogs {
      allNeBlog {
        nodes {
          handle
          tags
          publishedAt
          image {
            url
            altText
            src_sm
            src_md
            src_lg
            src_xl
          }
          seo {
            description
            title
          }
          contentHtml
          title
        }
      }
    }
  `).allNeBlog.nodes;
}
